import { Component, Input } from "@angular/core";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { PlanningState } from "../shared/store/planning.state";
import { IPlanningFilters } from "./../shared/model/interfaces";

import { PlanningHorizontalFiltersComponent } from "../shared/components/planning-horizontal-filters.component";

@Component({
  selector: "app-horizontal-filters",
  standalone: true,
  imports: [PlanningHorizontalFiltersComponent],
  template: `<ng-container>
    <app-planning-horizontal-filters
      class="d-flex"
      [placeholdertext]="placeholdertext"
      [disabled]="disabled"
    >
    </app-planning-horizontal-filters>
  </ng-container>`,
})
export class HorizontalFilterComponent {
  @Input() disabled = false;
  @Input() placeholdertext: string;

  filterState$: Observable<IPlanningFilters>;
  constructor(private store: Store) {
    this.filterState$ = store.select(PlanningState.filters);
  }
}
